<template>
  <section v-if="$role.restricAccess($route.name, 'view')">
    <breadcrumb-template
      :headtitle="$route.meta.title"
      :breadcrumbcurrent="$route.meta.title"
    ></breadcrumb-template>
    <v-card class="card-outline force-remove-box">
      <v-card-text class="force-custom-bg">
        <v-container fluid>
          <v-row dense class="d-flex justify-end mt-n2">
            <!-- <v-col cols="12" lg="2" class="span-label">
              <span>Region</span>
              <v-combobox
                class="regular-field"
                dense
                clearable
                :items="region_list"
                item-value="id"
                item-text="region_name"
                label="Region"
                v-model="filter.region_id"
              >
              </v-combobox>
            </v-col> -->
            <!-- <v-col cols="12" lg="2" class="span-label">
              <span>Area</span>
              <v-combobox
                class="regular-field"
                dense
                clearable
                :items="arealist"
                item-value="id"
                item-text="name"
                label="Area"
                v-model="filter.zone_id"
              >
              </v-combobox>
            </v-col> -->

            <v-col cols="12" lg="2" class="span-label">
              <span>Date from</span>
              <v-text-field
                clearable
                dense
                hide-details
                class="regular-field"
                v-model="filter.filterDateFrom"
                label="Date from"
                type="date"
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="2" class="span-label">
              <span>Date to</span>
              <v-text-field
                clearable
                dense
                hide-details
                class="regular-field"
                v-model="filter.filterDateTo"
                label="Date to"
                type="date"
              ></v-text-field>
            </v-col>

            <v-col cols="12" lg="3">
              <v-text-field
                clearable
                dense
                class="regular-field"
                v-model="dt_searchQuery"
                label="Search any keyword"
                hide-details
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2" class="mt-7" style="padding-top:5px;">
              <v-btn
                color="green_button"
                class="float-right btn-block"
                @click="getDataFromApi()"
                >Search</v-btn
              >
            </v-col>

            <!-- <v-col
              cols="12"
              lg="2"
              class="mt-7"
              style="padding-top:5px;"
              v-if="$role.restricAccess($route.name, 'add')"
            >
              <v-btn
                color="green_button"
                class="float-right btn-block"
                @click="modalForm"
                >Add result</v-btn
              >
            </v-col> -->

            <v-col cols="12" class="mt-2">
              <v-data-table
                class="custom-header-color table-bordered table-striped"
                :headers="dt_headers"
                :items="dt_resultlist"
                item-key="id"
                :loading="dt_loading"
                :options.sync="dt_options"
                :server-items-length="dt_totalResult"
              >
                <template v-slot:[`item.winners`]="{ item }">
                  <!-- <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"></v-avatar>  -->
                  {{ item.winners ? item.winners : 0 }}
                </template>

                <template v-slot:[`item.date`]="{ item }">{{
                  item.date | setDate
                }}</template>

                <template
                  v-slot:[`item.actions`]="{ item }"
                  v-if="$role.restricAccess($route.name, 'edit')"
                >
                  <v-btn color="info" block dark small @click="findData(item)">
                    Edit
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <section>
      <v-dialog v-model="dialogForm" width="550px" scrollable persistent>
        <v-card class="card-outline custom-color-dialog">
          <v-card-title class="headline headline_bg">
            <span v-if="modalUpdate">Update result</span>
            <span v-else>Create result</span>
          </v-card-title>

          <v-card-text>
            <v-row dense class="pt-6">
              <v-col cols="12" lg="12" class="span-label">
                <span>Region</span>
                <v-select
                  class="regular-field"
                  dense
                  clearable
                  @change="searchArea"
                  :items="drawregionlist"
                  item-value="id"
                  item-text="region_name"
                  label="Region"
                  v-model="form.region_id"
                >
                </v-select>
              </v-col>
              <v-col cols="12" lg="12" class="span-label">
                <span>Area</span>
                <v-select
                  class="regular-field"
                  dense
                  clearable
                  @change="getdrawlist"
                  :items="drawarealist"
                  item-value="id"
                  item-text="name"
                  label="Area"
                  v-model="form.zone_id"
                >
                </v-select>
              </v-col>

              <v-col cols="12" lg="12" class="span-label">
                <span>Draw</span>
                <v-select
                  :items="draw_list"
                  item-text="name"
                  item-value="id"
                  dense
                  class="regular-field"
                  v-model="form.draw_id"
                  label="Draw"
                  :error-messages="formerror.draw_id"
                ></v-select>
              </v-col>
              <v-col cols="12" lg="12" class="span-label">
                <span>Winning combination</span>
                <v-text-field
                  dense
                  class="regular-field"
                  v-model="form.combinations"
                  label="Winning combinatiion"
                  :error-messages="formerror.combinations"
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="12" class="span-label">
                <span>Date</span>
                <v-text-field
                  dense
                  class="regular-field"
                  v-model="form.date"
                  label="Date"
                  :error-messages="formerror.date"
                  type="date"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" lg="6">
                                <v-select :items="[{id: 0, name: 'Release now'}, {id: 1, name: 'Moderate'}]" item-text="name" item-value="id" dense outlined v-model="form.typewin" label="Type" :error-messages="formerror.typewin"></v-select>
                            </v-col> -->
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions class="actionButtons">
            <v-row no-gutters>
              <v-col cols="12">
                <v-btn color="error" @click="dialogForm = false">Back</v-btn>
                <span v-if="$role.restricAccess($route.name, 'edit')"
                  ><v-btn
                    color="green_button"
                    class="float-right"
                    @click="updateData"
                    v-if="modalUpdate"
                    :loading="isLoadingBtn"
                    >Update</v-btn
                  ></span
                >
                <v-btn
                  color="green_button"
                  class="float-right"
                  @click="newData"
                  v-if="!modalUpdate"
                  :loading="isLoadingBtn"
                  >Save</v-btn
                >
                <span v-if="$role.restricAccess($route.name, 'delete')"
                  ><v-btn
                    color="red_button"
                    class="float-right mr-3"
                    dark
                    :loading="isLoadingBtnDelete"
                    @click="deleteData(form.id)"
                    v-if="modalUpdate"
                    >Delete</v-btn
                  ></span
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </section>

    <confirm-dialog
      ref="confirm"
      class="custom-confirm-dialog"
    ></confirm-dialog>
  </section>
</template>

<script>
export default {
  data() {
    return {
      schedules: [
        { name: "Sunday" },
        { name: "Monday" },
        { name: "Tuesday" },
        { name: "Wednesday" },
        { name: "Thursday" },
        { name: "Friday" },
        { name: "Saturday" },
      ],
      dialogForm: false,
      isLoadingBtn: false,
      isLoadingBtnDelete: false,
      formerror: {},
      modalUpdate: false,
      dt_headers: [
        {
          text: "ID",
          value: "id",
          name: "id",
          align: " d-none",
        },
        {
          text: "Winning combinations",
          value: "combinations",
          name: "combinations",
        },
        {
          text: "Draw",
          value: "name",
          name: "name",
        },
        // {
        //   text: "Area",
        //   value: "zone_name",
        //   name: "zone_name",
        // },
        {
          text: "Date",
          value: "date",
          name: "date",
        },
        // {
        //   text: "GM winners",
        //   value: "totalgmwinners",
        //   name: "totalgmwinners",
        // },
        {
          text: "Winners",
          value: "winners",
          name: "winners",
        },
        // {
        //   text: "Actions",
        //   value: "actions",
        //   width: "10%",
        // },
      ],
      dt_options: {},
      dt_columns: {},
      dt_totalResult: 0,
      dt_searchInput: "",
      dt_searchQuery: "",
      dt_resultlist: [],
      dt_loading: true,
      dt_itemsPerPage: 50,
      dt_reload: "",
      dt_total_winnerprize: "",
      form: new this.$Form({
        id: "",
        draw_id: null,
        combinations: "",
        date: "",
        issendsms: true,
        typewin: 0,
        region_id: null,
        zone_id: null,
      }),
      draw_list: [],
      zone_list: null,
      region_list: [],
      arealist: [],
      drawarealist: [],
      drawregionlist: [],
      filter: {
        region_id: null,
        zone_id: null,
        filterDateFrom: this.$moment().format("YYYY-MM-DD"),
        filterDateTo: this.$moment().format("YYYY-MM-DD"),
      },
    };
  },
  methods: {
    schedule_draw_format(val) {
      // let data = [];
      // val = JSON.parse(val);
      // val.forEach(element => {
      //     data.push(element.name);
      // });
      // return data.join(', ');
    },
    modalForm() {
      this.form.reset();
      this.searchRegion();
      this.searchArea();
      this.getdrawlist();
      this.modalUpdate = false;
      this.form.reset();
      this.dialogForm = true;
    },
    copyClipboard(data) {
      data = data.split(" / ");
    },
    async newData() {
      let drawIndex = this.$_.findIndex(this.draw_list, (draw_list) => draw_list.id === this.form.draw_id);
      if(await this.$refs.confirm.open("Confirm", "Your about to save draw result with: <br />Draw: " + this.draw_list[drawIndex].name + "<br /> Combination: " + this.form.combinations)){
        this.$Fire.$emit("overlay", true);
        this.isLoadingBtn = true;
        this.form
          .post(this.$_CONFIG.api("API_DAILYRESULTS"))
          .then(({ data }) => {
            this.isLoadingBtn = false;
            this.getDataFromApi();
            this.dialogForm = false;
            this.form.reset();
            this.$toast.fire({icon: "success", title: "Record has been successfully added.",});
            this.$Fire.$emit("overlay", false);
          })
          .catch((error) => {
            this.isLoadingBtn = false;
            this.formerror = error.response.data.errors;
            this.$toast.fire({ icon: "error", title: "Something went wrong!" });
          });
      }
    },
    async findData(data) {
      this.formerror = {};
      this.form.reset();
      this.form.fill(data);
      // console.log(this.form);
      this.modalUpdate = true;
      this.dialogForm = true;
      this.searchRegion();
      this.searchArea();
      this.getdrawlist();
    },
    async updateData() {
      this.isLoadingBtn = true;
      this.form
        .put(this.$_CONFIG.api("API_DAILYRESULTS") + "/" + this.form.id)
        .then(() => {
          this.isLoadingBtn = false;
          this.dialogForm = false;
          this.getDataFromApi();
          this.$toast.fire({
            icon: "success",
            title: "Record has been successfully updated.",
          });
        })
        .catch((error) => {
          this.isLoadingBtn = false;
          this.formerror = error.response.data.errors;
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
    async deleteData(id) {
      this.isLoadingBtnDelete = true;
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to delete this record?"
        )
      ) {
        this.form
          .delete(this.$_CONFIG.api("API_DAILYRESULTS") + "/" + this.form.id)
          .then(() => {
            this.isLoadingBtnDelete = false;
            this.dialogForm = false;
            this.getDataFromApi();
            this.$toast.fire({
              icon: "success",
              title: "Record has been successfully deleted.",
            });
          })
          .catch(() => {
            this.isLoadingBtnDelete = false;
            this.$toast.fire({ icon: "error", title: "Something went wrong!" });
          });
      } else {
        this.isLoadingBtnDelete = false;
      }
    },
    paramsfilter() {
      return {
        ...this.dt_options,
        searchdata: this.dt_searchQuery,
        filterDateFrom: this.filter.filterDateFrom,
        filterDateTo: this.filter.filterDateTo,
        region_id: this.filter.region_id,
        zone_id: this.filter.zone_id,
      };
    },
    async getDataFromApi() {
      this.dt_loading = true;
      var paramsfilter = await this.paramsfilter();
      this.dt_columns = await this.$YajraDT.setHeader(this.dt_headers);
      let params = await this.$YajraDT.params(
        paramsfilter,
        this.dt_options,
        this.dt_itemsPerPage,
        this.dt_columns
      );
      let apiPath = (await this.$_CONFIG.api("API_DAILYRESULTS")) + "search";

      await this.$axios
        .post(apiPath + "?" + this.$.param(params))
        .then((res) => {
          if (this.dt_totalResult != res.data.recordsFiltered) {
            this.dt_options.page = 1;
          }

          this.dt_resultlist = res.data.data;
          this.dt_totalResult = res.data.recordsFiltered;
          this.dt_loading = false;
        })
        .catch((err) => {
          this.dt_loading = false;
          console.log(err);
        });

      var unwatch = this.$watch(
        "dt_options.page",
        function(newValue, oldValue) {
          this.getDataFromApi();
          unwatch();
        },
        { deep: true }
      );
    },
    getdrawlist() {
      this.form
        .post(this.$_CONFIG.api() + "/filterdrawresult")
        .then((res) => {
          this.draw_list = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async regionlist() {
      let response = await this.$axios.get(
        this.$_CONFIG.api() + "/allregionlist"
      );
      this.region_list = response.data;
    },
    getarealist() {
      this.$axios
        .get(this.$_CONFIG.api() + "/allzonelist")
        .then((res) => {
          this.arealist = res.data;
          // console.log(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    searchArea() {
      this.form
        .post(this.$_CONFIG.api() + "/drawarea")
        .then((res) => {
          this.drawarealist = res.data;
          console.log(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    searchRegion() {
      this.form
        .post(this.$_CONFIG.api() + "/drawregion")
        .then((res) => {
          this.drawregionlist = res.data;
          // console.log(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.getDataFromApi();
    this.regionlist();
    this.getarealist();
    this.searchRegion();
  },
  mounted() {},
};
</script>
<style scoped></style>